import React from 'react'

const CardHeading = ({text}: {text: string}) => {
  return <span className='text-textColor font-semibold'>{text}</span>
}

export default CardHeading
